export default __webpack_public_path__ + "static/palette-jira-board-light-e02376f71a94c28fcfd5052503aec34015c4d4c322887c3626315b9eefe7c219.png";